export default "__VITE_ASSET__BrxU9nEN__"